import { render, staticRenderFns } from "./card-suggested.vue?vue&type=template&id=3588c9db&scoped=true"
import script from "./card-suggested.vue?vue&type=script&lang=js"
export * from "./card-suggested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588c9db",
  null
  
)

export default component.exports